// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-E":"TabE_outdoor-recreation-E__Koggd"};